import { IRevenueSpendByTeamPageLang } from '../../../types/lang'

export const revenueSpendByTeamPageLang: IRevenueSpendByTeamPageLang = {
	revenue_spend_by_team_page: {
		btn_show_empty_spend_agency_columns: 'Show empty Spend Agency columns',
		btn_hide_empty_spend_agency_columns: 'Hide empty Spend Agency columns',
	}
}